import * as React from 'react';
var defaults = {
  setPageTitle: function () {}
};
var context = React.createContext(defaults);
export var PageTitleProvider = context.Provider;
export var usePageTitle = function () {
  return React.useContext(context);
};